import finalMovieList from "./movie";

export default {
  contact: {
    description: "Return a list of my contact information.",
    list: [
      {
        type: "info",
        label: "Email:",
        content: "`hi@simonaking.com`",
      },
      {
        type: "info",
        label: "Github:",
        content: "`https://github.com/SimonAKing`",
      },
      {
        type: "info",
        label: "X:",
        content: "`https://x.com/simon_aking`",
      },
      {
        type: "info",
        label: "Wechat:",
        content: "`simonaking`",
      },
    ],
  },
  // whoami: {
  //   description: 'Return a piece of code about tomotoes.',
  //   list: [
  //     {
  //       type: 'success',
  //       label: 'Compiled',
  //       content: '1   const'
  //     },
  //     {
  //       type: 'success',
  //       label: 'Compiled',
  //       content: '2     tomatoes = "番茄",'
  //     },
  //     {
  //       type: 'success',
  //       label: 'Compiled',
  //       content: '3     tomotoes = "坏掉的番茄";'
  //     },
  //     {
  //       type: 'success',
  //       label: 'Compiled',
  //       content: '4   const myTomotoes = new Promise((resolve, reject) => {'
  //     },
  //     {
  //       type: 'warning',
  //       label: 'Compiled',
  //       content: '5     tomatoes === "番茄"?resolve(tomotoes):reject(tomatoes)'
  //     },
  //     {
  //       type: 'success',
  //       label: 'Compiled',
  //       content: '6   }).then(()=>"My tomatoes,I\'m coming!")'
  //     },
  //     {
  //       type: 'error',
  //       label: 'SyntaxError',
  //       content: '7   .catch(()=>"What the f*ck!");'
  //     }
  //   ]
  // },
  skill: {
    description: "Return a list of my skills and my rating of them.",
    list: [
      { type: "success", label: "A", content: "· Go 90/100" },
      { type: "success", label: "A", content: "· TypeScript 90/100" },
      { type: "success", label: "A", content: "· Python 80/100" },

      { type: "warning", label: "B", content: "· Java 70/100" },
      { type: "warning", label: "B", content: "· Kotlin 70/100" },
      { type: "warning", label: "B", content: "· C 70/100" },
      { type: "warning", label: "B", content: "· Shell 70/100" },

      { type: "error", label: "C", content: "· C# 60/100" },
      { type: "error", label: "C", content: "· Rust 60/100" },
      { type: "error", label: "C", content: "· Scala 60/100" },
      { type: "error", label: "C", content: "· Lua 60/100" },
      { type: "error", label: "C", content: "· Haskell 60/100" },
      { type: "error", label: "C", content: "· Ruby 60/100" },

      { type: "black", label: "D", content: "· CSS -999/100" },
    ],
  },
  cartoon: {
    description: "Return a list of cartoons that I have watched.",
    list: [
      " 《 海绵宝宝 》",
      " 《 一人之下 》",
      " 《 镇魂街 》",
      " 《 一拳超人 》",
      " 《 某科学的超电磁炮 》",
      " 《 罗小黑战记 》",
      " 《 鬼灭之刃 》",
      " 《 辉夜大小姐想让我告白 》",
      " 《 笨女孩 》",
      " 《 埃罗芒阿老师 》",
      " 《 Charlotte 》",
      " 《 灵笼 》",
      " 《 干物妹！小埋 》",
      " 《 这个勇者明明超强却过分慎重 》",
      " 《 天气之子 》",
      " 《 因为太怕痛就全点防御力了 》",
      " 《 四月是你的谎言 》",
      " 《 夏目友人帐 》",
      " 《 咒术回战 》",
      " 《 小林家的龙女仆 》",
      " 《 齐木楠雄的灾难 》",
      " 《 关于完全听不懂老公在说什么的事 》",
      " 《 黑门 》",
      " 《 我的三体之罗辑传 》",
      " 《 间谍过家家 》",
      " 《 夏日重现 》",
      " 《 异世界舅舅 》",
      " 《 怪兽8号 》",
      " 《 英雄联盟：双城之战 》",
      " 《 我独自升级 》",
    ],
  },
  book: {
    description: "Return a list of books that I have read.",
    list: [
      " 《 JavaScript 高级程序设计 》--- Nicholas C.Zakas ",
      " 《 JavaScript 标准参考教程 》--- 阮一峰 ",
      " 《 ECMAScript 6 入门 》--- 阮一峰 ",
      " 《 JavaScript DOM 高级程序编程艺术 》--- Jeremy Keith ",
      " 《 锋利的 jQuery 》--- 单东林 ",
      " 《 CSS 揭秘 》--- LEA VEROU ",
      " 《 CSS 权威指南 》--- Eric A.Meyer ",
      " 《 HTML5 高性能指南 》--- 布莱恩特/琼斯 ",
      " 《 C# 本质论 》--- MarkMichaelis ",
      " 《 C# 入门经典 2015 》--- karli ",
      " 《 C# 多线程编程实战 》--- 阿格佛温 ",
      " 《 C primer plus(第六版) 》--- Stephen Prata ",
      " 《 算法导论 》--- Thomas H.Cormen... ",
      " 《 算法竞赛入门经典(第一版) 》--- 刘汝佳 ",
      " 《 算法竞赛入门经典(第二版) 》--- 刘汝佳 ",
      " 《 Vim 实战技巧 》--- Drew Neil ",
      " 《 你不知道的 JavaScript-下 》--- Kyle Simpson ",
      " 《 Linux 命令行大全 》--- William E.shotts，Jr ",
      " 《 写给大忙人看的 Java 核心技术 》--- CayS.Horstmann ",
      " 《 Python Cookbook 》--- Alex Martelli... ",
      " 《 暗时间 》--- 刘未鹏 ",
      "  《 Haskell 趣学指南 》--- 斯洛文尼亚 ",
      " 《 数学之美（第二版） 》--- 吴军 ",
      " 《 Linux Bash 编程与脚本应用实战 》--- 马玉军 郝军 ",
      " 《 程序员的呐喊 》--- Steve Yegge ",
      " 《 The way to go 》--- 无闻 ",
      " 《 The Go Programming Language 》--- Brian W. Kernighan... ",
      " 《 Java 编程思想 （第4版） 》--- Bruce Eckel ",
      " 《 Kotlin 核心编程 》--- 水滴团队 ",
      " 《 Easy Kotlin 》--- JackChan ",
      " 《 HTTP 图解 》--- 上野宣 ",
      " 《 刘大猫的财富之旅 》--- 刘欣 ",
      " 《 ZOO 》--- 乙一 ",
      " 《 macOS效率手册 》--- 少数派 ",
      " 《 深入理解 TypeScript 》--- Basarat ",
      " 《 淘宝技术这十年 》--- 子柳 ",
      " 《 大型网站技术架构 》--- 李智慧 ",
      " 《 分布式服务架构：原理、设计与实战 》--- 李艳鹏 / 杨彪 ",
      " 《 前端架构：从入门到微前端 》--- 黄峰达（Phodal） ",
      " 《 生活蒙太奇 》--- 天然 ",
      " 《 前方的路 》--- 阮一峰 ",
      " 《 未来世界的幸存者 》--- 阮一峰 ",
      " 《 天才在左疯子在右 》--- 高铭 ",
      " 《 字节跳动：从0到1的秘密 》--- 马修 布伦南 ",
      " 《 王慧文清华产品课 》--- 王慧文 ",
      " 《 产品思维30讲 》--- 梁宁 ",
      " 《 增长思维30讲 》--- 梁宁 ",
      " 《 商业参考2 》--- 蔡钰 ",
      " 《 三体 》--- 刘慈欣 ",
    ],
  },
  movie: {
    description: "Return a list of movies that I have watched.",
    list: finalMovieList,
  },
};
